import { actionCreator } from 'utils';
import * as PropertyTypes from '../types/propertyTypes';

const initState = {
    loading: false,
    error: false,
    success: false,
    listing: {},
    offset: 0,
    limit: 10,
    sort: null,
    listCarriers: {},
    listPropertyValues: {
        loading: false,
        error: false,
        data: null,
        add: {
            loading: false,
        },
        offset: 0,
        limit: 10,
        filters: {
            name: '',
        },
        edit: {
            loading: false,
            error: false,
            data: null,
        },
    },
    selected: {
        loading: false,
        error: false,
        data: null,
    },
    add: {
        loading: false,
        error: false,
        success: false,
        current: 0,
    },
    edit: {
        loading: false,
        data: null,
        error: false,
        success: false,
    },
    delete: {
        loading: false,
        error: false,
    },
    filters: {
        name: '',
        property_type: [],
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case PropertyTypes.LOAD_PROPERTIES:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(PropertyTypes.LOAD_PROPERTIES, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(PropertyTypes.LOAD_PROPERTIES, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case PropertyTypes.SET_PROPERTY_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case PropertyTypes.SET_PROPERTY_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case PropertyTypes.ADD_NEW_PROPERTY:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(PropertyTypes.ADD_NEW_PROPERTY, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: action.loading,
                error: false,
            }),
        });

    case actionCreator(PropertyTypes.ADD_NEW_PROPERTY, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: false,
                error: action.error,
            }),
        });

    case PropertyTypes.UPDATE_TRANSLATE_PROPERTY:
        return Object.assign({}, state, {
            [action.key]: Object.assign({}, state[action.key], {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(PropertyTypes.UPDATE_TRANSLATE_PROPERTY, 'res'):
        return Object.assign({}, state, {
            [action.key]: Object.assign({}, state[action.key], {
                loading: action.loading,
                success: action.success,
            }),
        });

    case PropertyTypes.GO_TO_STEP_OF_PROPERTY_FORM:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                current: action.step,
            }),
        });

    case PropertyTypes.LOAD_EDITABLE_PROPERTY:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(PropertyTypes.LOAD_EDITABLE_PROPERTY, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(PropertyTypes.LOAD_EDITABLE_PROPERTY, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case PropertyTypes.EDIT_PROPERTY:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(PropertyTypes.EDIT_PROPERTY, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                success: action.state,
            }),
        });

    case actionCreator(PropertyTypes.EDIT_PROPERTY, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case PropertyTypes.EDIT_PROPERTY_FORM_CARRIERS:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                data: {
                    ...state.edit.data,
                    carriers: action.carriers,
                },
            }),
        });

    case PropertyTypes.SET_EMPTY_EDITABLE_PROPERTY:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: null,
                error: false,
            }),
        });

    case PropertyTypes.SET_PROPERTY_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(PropertyTypes.SET_PROPERTY_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case PropertyTypes.SET_PROPERTY_TYPE_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                property_type: action.key,
            },
        });


    case actionCreator(PropertyTypes.SET_PROPERTY_TYPE_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case PropertyTypes.RESET_FILTER_PROPERTIES:
        return Object.assign({}, state, {
            ...state,
            loading: true,
            filters: {
                name: '',
                property_type: [],
            },
        });

    case actionCreator(PropertyTypes.RESET_FILTER_PROPERTIES, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case PropertyTypes.LOAD_PROPERTY_VALUES:
        return Object.assign({}, state, {
            listPropertyValues: Object.assign({}, state.listPropertyValues, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(PropertyTypes.LOAD_PROPERTY_VALUES, 'res'):
        return Object.assign({}, state, {
            listPropertyValues: Object.assign({}, state.listPropertyValues, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(PropertyTypes.LOAD_PROPERTY_VALUES, 'err'):
        return Object.assign({}, state, {
            listPropertyValues: Object.assign({}, state.listPropertyValues, {
                loading: false,
                error: true,
            }),
        });

    case PropertyTypes.SET_PROPERTY_VALUES_FILTERS:
        return Object.assign({}, state, {
            listPropertyValues: Object.assign({}, state.listPropertyValues, {
                loading: true,
                filters: {
                    ...state.listPropertyValues.filters,
                    [action.key]: action.value,
                },
            }),
        });

    case actionCreator(PropertyTypes.SET_PROPERTY_VALUES_FILTERS, 'res'):
        return Object.assign({}, state, {
            listPropertyValues: Object.assign({}, state.listPropertyValues, {
                loading: false,
                data: action.data,
            }),
        });

    case PropertyTypes.SET_PROPERTY_VALUES_PAGINATION:
        return Object.assign({}, state, {
            listPropertyValues: Object.assign({}, state.listPropertyValues, {
                [action.key]: action.value,
            }),
        });

    case PropertyTypes.ADD_PROPERTY_VALUE_TO_PROPERTY:
        return Object.assign({}, state, {
            listPropertyValues: Object.assign({}, state.listPropertyValues, {
                add: {
                    ...state.listPropertyValues.add,
                    loading: true,
                    error: false,
                    success: false,
                },
            }),
        });

    case actionCreator(PropertyTypes.ADD_PROPERTY_VALUE_TO_PROPERTY, 'res'):
        return Object.assign({}, state, {
            listPropertyValues: Object.assign({}, state.listPropertyValues, {
                add: {
                    ...state.listPropertyValues.add,
                    loading: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(PropertyTypes.ADD_PROPERTY_VALUE_TO_PROPERTY, 'err'):
        return Object.assign({}, state, {
            listPropertyValues: Object.assign({}, state.listPropertyValues, {
                add: {
                    ...state.listPropertyValues.add,
                    loading: false,
                    error: action.error,
                },
            }),
        });

    case PropertyTypes.LOAD_PROPERTY_FOR_EDITING_PROPERTY_VALUES:
        return Object.assign({}, state, {
            selected: {
                ...state.selected,
                loading: true,
                error: false,
            },
        });

    case actionCreator(PropertyTypes.LOAD_PROPERTY_FOR_EDITING_PROPERTY_VALUES, 'res'):
        return Object.assign({}, state, {
            selected: {
                ...state.selected,
                loading: false,
            },
        });

    case actionCreator(PropertyTypes.LOAD_PROPERTY_FOR_EDITING_PROPERTY_VALUES, 'err'):
        return Object.assign({}, state, {
            selected: {
                ...state.selected,
                loading: false,
                error: true,
            },
        });

    case PropertyTypes.SET_SELECTED_PROPERTY:
        return Object.assign({}, state, {
            selected: {
                ...state.selected,
                data: action.selected,
            },
        });

    case PropertyTypes.SET_EDITABLE_PROPERTY_VALUE:
        return Object.assign({}, state, {
            listPropertyValues: Object.assign({}, state.listPropertyValues, {
                edit: {
                    ...state.listPropertyValues.edit,
                    data: action.data,
                },
            }),
        });

    case PropertyTypes.EDIT_PROPERTY_VALUE_TO_PROPERTY:
        return Object.assign({}, state, {
            listPropertyValues: Object.assign({}, state.listPropertyValues, {
                edit: {
                    ...state.listPropertyValues.edit,
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(PropertyTypes.EDIT_PROPERTY_VALUE_TO_PROPERTY, 'res'):
        return Object.assign({}, state, {
            listPropertyValues: Object.assign({}, state.listPropertyValues, {
                edit: {
                    ...state.listPropertyValues.edit,
                    loading: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(PropertyTypes.EDIT_PROPERTY_VALUE_TO_PROPERTY, 'err'):
        return Object.assign({}, state, {
            listPropertyValues: Object.assign({}, state.listPropertyValues, {
                edit: {
                    ...state.listPropertyValues.edit,
                    loading: false,
                    error: action.error,
                    success: false,
                },
            }),
        });

    case PropertyTypes.DELETE_PROPERTY_VALUE:
        return Object.assign({}, state, {
            delete: Object.assign({}, state.delete, {
                loading: action.propertyValueId,
                error: false,
            }),
        });

    case actionCreator(PropertyTypes.DELETE_PROPERTY_VALUE, 'res'):
        return Object.assign({}, state, {
            delete: Object.assign({}, state.delete, {
                loading: false,
                error: false,
            }),
        });

    case actionCreator(PropertyTypes.DELETE_PROPERTY_VALUE, 'err'):
        return Object.assign({}, state, {
            delete: Object.assign({}, state.delete, {
                loading: false,
                error: action.error,
            }),
        });

    default:
        return state;
    }
}
